import { Form } from "formik";
import styled from "styled-components";
import { device } from "../../../constants/mediaQueries";

export const SPForm = styled(Form)`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 700px;
  max-width: 100%;

  .p-inputtext:enabled:focus {
    box-shadow: 0 0 0 0.1rem var(--primary-300);
  }

  .p-textarea:enabled:focus {
    box-shadow: 0 0 0 0.1rem var(--primary-300);
  }

  .form-sections-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 3rem;
  }

  .form-section {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    width: 100%;

    &__add-btn {
      width: 100%;
      display: flex;
      justify-content: flex-end;
    }

    &__subtitle {
      width: 100%;
      display: flex;
      justify-content: flex-start;
    }

    &__subtitle-btn-container {
      width: 100%;
      display: flex;
      justify-content: space-between;
    }

    &__label-btn-container {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
    }

    &__fields {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 1.3rem;

      &--no-subtitles {
        width: 100%;
        margin-top: 2rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 2rem;
      }

      &--fieldarr {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        gap: 0.5rem;
      }

      &--group-wrapper {
        display: flex;
        gap: 0.5rem;
        width: 100%;
        margin-bottom: 1rem;
      }

      &--single-wrapper {
        display: flex;
        gap: 0.5rem;
        width: 100%;
      }

      &--group {
        display: flex;
        flex-direction: column;
        gap: 1.5rem;
        width: 100%;

        @media ${device.md} {
          flex-direction: row;
        }
      }

      &--field-btn {
        width: 100%;
        display: flex;
        gap: 0.5rem;

        button {
          height: 2.7rem;
        }
      }

      &--datetime-group {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        gap: 1rem;
        width: 100%;

        .sp-formik-input-text-container {
          width: max(10%, 100px);
        }
      }

      &--checkBox {
        width: 100%;
        padding-top: 1rem;
      }

      .no-label {
        label {
          display: none;
        }
      }
    }

    &__fieldarr-group {
      gap: 0.5rem;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }

  .fieldArr-error {
    width: 100%;
    display: flex;
    color: var(--red-700);
    font-size: 0.875rem;
    &__msg {
      color: var(--red-700);
    }
  }

  .fallback-msg {
  }

  .form-button-container {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    gap: 1rem;
    padding: 1rem 0;
    margin: 1rem 0;

    &--sticky {
      position: sticky;
      bottom: 0;
      margin-left: -0.25rem;
      margin-right: -0.25rem;
      padding-left: 0.25rem;
      padding-right: 0.25rem;
      width: calc(100% + 0.5rem);

      // background linear gradient, transparent on top
      background: linear-gradient(
        to bottom,
        rgba(255, 255, 255, 0) 0%,
        var(--surface-card) 20%
      );
    }

    &__inner {
      display: flex;
      width: fit-content;
      gap: 1rem;
    }
  }
`;
